export class HHAPIService {
  constructor(protected serviceCategory: string) {}

  getClientTypeHeaders(clientType: string) {
    return {
      'X-Api-Client-Type': clientType
    };
  }
}
